import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/useToast';
import { showDevError } from '@/components/ui/dev-error-toast';
import { useI18n } from "@/hooks/useI18n";
import type { TranslationKey } from '@/types/i18n.types';

/**
 * Lettura di una singola travel request, per il builder. Le liste stanno in
 * useDashboardLists e le azioni (accetta, assegna, chiudi) in useTravelRequestActions.
 */
export const useTravelRequests = () => {
  const { t } = useI18n();

  const fetchTravelRequest = useCallback(async (requestId: string) => {
    try {
      const { data, error } = await supabase
        .from('travel_requests')
        .select('*')
        .eq('id', requestId)
        .single();

      if (error) {
        console.error('Error fetching travel request:', error);
        showDevError({ error, context: 'fetching travel request' });
        toast({
          title: t('common.error'),
          // travelRequestMessages esiste nei json ma non e' fra i namespace tipizzati.
          description: t('travelRequestMessages.loadRequestDataError' as TranslationKey),
          variant: "destructive",
        });
        return null;
      }

      return data;
    } catch (error) {
      console.error('Unexpected error fetching travel request:', error);
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fetchTravelRequest };
};
